// extracted by mini-css-extract-plugin
module.exports = {"withSticky":"_191f0b","title":"_7b33b3","content":"_448daf","itemsList":"_2ae3df","compareButton":"_e4896a","compareButtonContent":"_2cb273"};